export default "__VITE_ASSET__BnUsjOBo__"